module.exports = __webpack_public_path__ + "img/star-empty.8a29c71c.svg";